import React, { useId } from 'react';
import { Form } from 'react-bootstrap';

export default function PlanningFilters({ machines, category, machine, onCategoryChange, onMachineChange }) {
    const filterId = useId();
    const activeMachines = machines.filter(item => item.active !== false);
    // HomePage's PE&P categories are the descriptions supplied by getAllMachines.
    const categories = [...new Set(activeMachines.map(item => item.description).filter(Boolean))];
    const machineNames = [...new Set(activeMachines
        .filter(item => !category || item.description === category)
        .map(item => String(item.machine || '').trim())
        .filter(Boolean))].sort((left, right) => left.localeCompare(right));

    return (
        <div className="planning-overview__filters" role="group" aria-label="Planning filters">
            <div className="planning-overview__filter-field">
                <Form.Label htmlFor={`${filterId}-category`}>Category</Form.Label>
                <Form.Select id={`${filterId}-category`} value={category} onChange={event => onCategoryChange(event.target.value)}>
                    <option value="">All categories</option>
                    {categories.map(value => <option key={value} value={value}>{value}</option>)}
                </Form.Select>
            </div>
            <div className="planning-overview__filter-field">
                <Form.Label htmlFor={`${filterId}-machine`}>Machine or line</Form.Label>
                <Form.Select id={`${filterId}-machine`} value={machine} onChange={event => onMachineChange(event.target.value)}>
                    <option value="">All machines/lines</option>
                    {machineNames.map(value => <option key={value} value={value}>{value}</option>)}
                </Form.Select>
            </div>
        </div>
    );
}
